'use client'

import { ArrowRight } from '@/components/svg/arrow-right/arrow-right'
import { Slider } from '@/components/v2/atoms/slider/slider'
import { SupplierLocation } from '@/types/Supplier'
import cx from 'classnames'
import { KeenSliderOptions } from 'keen-slider'
import React from 'react'
import s from './slider-with-navigation.module.scss'

interface Props {
  children: React.ReactNode
  navigationPosition?: 'right' | 'left'
  title: React.ReactNode
  keenSliderOptions?: KeenSliderOptions
  fullWidth?: boolean
  topWrapperClassName?: string
  slidesWrapperClassName?: string
  sliderContainerClassName?: string
  sliderControlsClassName?: string
  sliderSubtitleControlsClassName?: string
  sliderArrowClassName?: string
  navigationVisible?: boolean
  navigationIconsColor?: string
  subTitle?: React.ReactNode
  /** Rendered under the arrows, inside the same wrapper as the title. */
  belowNavigation?: React.ReactNode
}

export const SliderWithNavigation = ({
  children,
  navigationPosition = 'right',
  title,
  keenSliderOptions,
  fullWidth,
  topWrapperClassName,
  slidesWrapperClassName,
  sliderControlsClassName,
  sliderArrowClassName,
  navigationVisible = true,
  navigationIconsColor = '#131313',
  sliderSubtitleControlsClassName,
  subTitle,
  belowNavigation,
}: Props) => {
  return (
    <Slider
      ignoreDefaultBreakpoints
      className={slidesWrapperClassName}
      options={{
        initial: 0,
        slides: {
          spacing: 16,
          perView: 'auto',
        },
        breakpoints: {},
        ...keenSliderOptions,
      }}
      renderNavigation={(slideLeft, slideRight) => {
        return (
          <>
            <div
              className={cx(s.topWrapper, topWrapperClassName, {
                [s.navigationToLeft]: navigationPosition === 'left',
                [s.fullWidth]: fullWidth,
              })}
            >
              {title}
              {navigationVisible && (
                <div className={cx(s.sliderControls, sliderControlsClassName)}>
                  <button
                    onClick={slideLeft}
                    className={cx(s.sliderArrow, sliderArrowClassName)}
                    aria-label="Previous slide"
                  >
                    <ArrowRight
                      iconColor={navigationIconsColor}
                      svgProps={{
                        style: {
                          transform: 'rotate(180deg)',
                        },
                      }}
                    />
                  </button>
                  <button
                    onClick={slideRight}
                    className={cx(s.sliderArrow, sliderArrowClassName)}
                    aria-label="Next slide"
                  >
                    <ArrowRight iconColor={navigationIconsColor} />
                  </button>
                </div>
              )}
              {belowNavigation}
            </div>
            {subTitle && (
              <div className={s.subTitleContainer}>
                {subTitle}{' '}
                {navigationVisible && (
                  <div
                    className={cx(
                      s.sliderControls,
                      sliderSubtitleControlsClassName
                    )}
                  >
                    <button
                      onClick={slideLeft}
                      className={cx(s.sliderArrow, sliderArrowClassName)}
                      aria-label="Previous slide"
                    >
                      <ArrowRight
                        iconColor={navigationIconsColor}
                        svgProps={{
                          style: {
                            transform: 'rotate(180deg)',
                          },
                        }}
                      />
                    </button>
                    <button
                      onClick={slideRight}
                      className={cx(s.sliderArrow, sliderArrowClassName)}
                      aria-label="Next slide"
                    >
                      <ArrowRight iconColor={navigationIconsColor} />
                    </button>
                  </div>
                )}
              </div>
            )}
          </>
        )
      }}
    >
      {children}
    </Slider>
  )
}
